import { useEffect } from 'react';
import { UseFormatViewReturn } from '../types';
import { useAppSelector, useAppDispatch } from '~app/hooks';
import { register, unregister } from '~app/components/Survey/SurveyFormat';

export default function useFormatView<T extends HTMLElement = HTMLElement>(name: string): UseFormatViewReturn<T> {
  // computed state will only re-render if computed value changes
  const isActive = useAppSelector(state => state.surveyFormat.active === name);
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(register(name));
    return () => {
      dispatch(unregister(name));
    };
  }, [dispatch, name]);

  return { isActive };
}
